// Deployment URLs resolved at runtime instead of being baked in at build time.
//
// The deployment (ansible frontend role) serves a /config.json next to each
// site containing { apiUrl, signalrUrl, universalSearchUrl }. loadRuntimeConfig()
// is awaited by each app's entry point before the app module is evaluated, so
// every consumer sees the final values. When no config.json is served (npm run
// serve, legacy cloud-init deployments) the values baked in from the .env files
// are used instead.
const runtimeConfig = {
    apiUrl: process.env.VUE_APP_API_URL,
    signalrUrl: process.env.VUE_APP_SIGNALR_URL,
    universalSearchUrl: process.env.VUE_APP_UNIVERSALSEARCH_URL,
};

export async function loadRuntimeConfig() {
    try {
        const response = await fetch(`${process.env.BASE_URL}config.json`, { cache: 'no-store' });
        if (response.ok) {
            Object.assign(runtimeConfig, await response.json());
        }
    } catch (e) {
        // Not served here — keep the build-time values.
    }
    return runtimeConfig;
}

export default runtimeConfig;
